import React from 'react'

// React Router Dom Link
import Slider from '../Package/Slider';


function Overview() {
  return (
    <>

      {/* #overview */}
      <section className="overview section" id="overview" aria-label="overview">
        <div className="container" style={{ marginTop: "30px" }}>
          <h2
            className="headline headline-2 section-title"
            style={{ fontSize: "4.5rem" }}
          >
            <span className="span">An Overview.</span>
          </h2>
          <p className="section-text hide">
            Prabhjeet Singh is a living testament to the boundless potential
            within a single individual. He is a shining example of how one
            person can excel in numerous areas. He's an entrepreneur who turns
            ideas into reality, a lifestyle influencer who inspires people to be
            themselves, and a web application developer who builds beautiful and
            functional websites. He's also a cinematographer, capturing life's
            special moments on camera, and a food blogger who shares his love
            for different cuisines. Through YouTube and other content, he
            spreads knowledge and stories that resonate globally. Adding to his
            list of talents, he's a fashion model, representing elegance and
            style. Prabhjeet Singh's journey proves that having diverse skills
            and an unwavering drive can open endless doors and reshape the world
            around us.
          </p>

          {/* Slider Section Starts Here*/}
          <Slider />
          {/* Slider Section Ends Here*/}

        </div>
      </section>
    </>
  );
}

export default Overview